import { render, staticRenderFns } from "./OficialesRegistro.vue?vue&type=template&id=30f0575b"
import script from "./OficialesRegistro.vue?vue&type=script&lang=js"
export * from "./OficialesRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30f0575b')) {
      api.createRecord('30f0575b', component.options)
    } else {
      api.reload('30f0575b', component.options)
    }
    module.hot.accept("./OficialesRegistro.vue?vue&type=template&id=30f0575b", function () {
      api.rerender('30f0575b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/autoridad-certificante/OficialesRegistro.vue"
export default component.exports